export default "__VITE_ASSET__i3T4tO$D__"